import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import AudienceEditForm from './AudienceEditForm';
import AudienceList from './AudienceList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import AudienceListView from './AudienceListView'


export default function AudienceDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.audienceDashboard);
  const [ audienceId, setAudienceId] = React.useState('');
  const [reloadAudienceList, setReloadAudienceList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <AudienceEditForm 
            setReloadAudienceList={setReloadAudienceList}
            audienceId={audienceId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <AudienceListView 
                      setAudienceId = {setAudienceId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
